/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import canUseDom from '@clearscore/helpers.can-use-dom';

function getValue(mediaQueryLists, values) {
    const index = mediaQueryLists.findIndex((mql) => mql.matches);
    if (Array.isArray(values)) {
        return typeof values[index] === 'undefined' ? values[0] : values[index];
    }
    return values;
}

function useMedia(queries, values) {
    const isBrowser = canUseDom();
    // fall back to first query if rendering on the server as window is unavailable
    const mediaQueryLists = isBrowser ? queries.map((q) => window.matchMedia(q)) : [true];
    const [value, setValue] = useState(getValue(mediaQueryLists, values));

    function setState() {
        setValue(getValue(mediaQueryLists, values));
    }

    useEffect(() => {
        if (canUseDom()) {
            mediaQueryLists.forEach((mql) => mql.addListener(setState));
        }

        setState();
        return () => {
            if (canUseDom()) {
                mediaQueryLists.forEach((mql) => mql.removeListener(setState));
            }
        };
    }, [queries, values, isBrowser]);

    return value;
}

export default useMedia;
